
'use strict';

define('component!Pricing/PricingUpgradeOnlyBoxComponent',['require','underscore','prop-types','react','create-react-class','react-dom','classnames','lib/prototype/Array.prototype','component!Pricing/PricingChangeTierComponent','lib/view_helpers/pricingTierPlans','translate','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Routes','lib/Podio.Utils','component!Raw'],function (require) {
  'use strict';

  var _ = require('underscore');
  var PropTypes = require('prop-types');
  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var ReactDOM = require('react-dom');
  var cx = require('classnames');
  require('lib/prototype/Array.prototype');

  var PricingChangeTierComponent = React.createFactory(require('component!Pricing/PricingChangeTierComponent'));
  var PricingTierPlans = require('lib/view_helpers/pricingTierPlans');
  var t = require('translate');

  var API = require('lib/backbone/Backbone.Mixins.Transport.API');

  var routes = require('lib/Podio.Routes');
  var utils = require('lib/Podio.Utils');

  var Raw = require('component!Raw');

  var features = {
    'unlimitedUsers': t('Unlimited users #better_paywall'),
    'lightUser': t('Light user role #better_paywall'),
    'training': t('Training sessions #better_paywall'),
    'prioritySupport': t('Priority support #better_paywall'),
    'globiflow': t('GlobiFlow #better_paywall')
  };

  var tiers = [{
    id: 'free',
    price: 0,
    features: []
  }, {
    id: 'basic',
    price: 9,
    features: [features.unlimitedUsers]
  }, {
    id: 'plus',
    price: 14,
    features: [features.unlimitedUsers, features.lightUser]
  }, {
    id: 'premium',
    price: 24,
    features: [features.unlimitedUsers, features.lightUser, features.prioritySupport, features.globiflow]
  }];

  var PricingUpgradeOnlyBoxComponent = ReactCreateClass({
    displayName: 'PricingUpgradeOnlyBoxComponent',

    propTypes: {
      needs: PropTypes.arrayOf(PropTypes.oneOf(_.pluck(tiers, 'id'))),
      downgrade: PropTypes.bool,
      tracking: PropTypes.shape({
        category: PropTypes.string,
        value: PropTypes.string,
        customDimension: PropTypes.object
      }),
      openModalDelegate: PropTypes.func,
      closeModalDelegate: PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
      return {
        needs: [],
        downgrade: true,
        tracking: {},
        showFree: true
      };
    },

    getInitialState: function getInitialState() {
      return {
        currentTier: 'free',
        upgradePath: '',
        endPlanPath: ''
      };
    },

    componentDidMount: function componentDidMount() {
      this._isMounted = true;
    },

    componentWillUnmount: function componentWillUnmount() {
      this._isMounted = false;
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      utils.getOrgByUrlLabel().done((function (organization) {
        if (this._isMounted) {
          this.setState({
            currentTier: organization.tier || 'free',
            upgradePath: routes.organization_upgrade_tier_path(organization.url_label, { format: 'html' }),
            endPlanPath: '' // FIXME
          });
        }
      }).bind(this));
    },

    render: function render() {
      var needsList = this.props.needs.map(function (str) {
        return '<strong>' + str + '</strong>';
      }).toSentence(', ', [' ', t('or #better_paywall').trim(), ' '].join(''));

      if (this.props.showFree === false) {
        tiers = tiers.filter(function (tier) {
          return tier.id !== 'free';
        });
      }

      return React.createElement(
        'section',
        { className: 'pricing-upgrade-only-box-component' },
        React.createElement(
          'p',
          { className: 'upgrade-description' },
          this.props.needs.length > 0 ? React.createElement(
            Raw,
            null,
            t("You'll need the {0} plan to enable Advanced workflows #better_paywall").format(needsList)
          ) : null
        ),
        React.createElement(
          'ul',
          { className: 'pricing-upgrade-only-box-component__tiers' },
          tiers.map(this.renderBox)
        )
      );
    },

    renderChangeTierComponent: function renderChangeTierComponent() {
      // modal inception doesn't really work, so doing this instead
      var node = document.body.querySelector('.change-tier-placeholder');

      if (!_.isElement(node)) {
        node = document.createElement('div');
        node.className = 'change-tier-placeholder';

        document.body.appendChild(node);
      }

      this.changeTierInstance = ReactDOM.render(PricingChangeTierComponent({
        isOpen: true,
        tier: this.state.selectedTier,
        isUpgrade: this.state.isUpgrade,
        onClose: this.props.openModalDelegate
      }), node);

      this.changeTierInstance.open();
    },

    renderBox: function renderBox(tier) {
      var boxClasses = cx({
        'pricing-tier-box': true,
        'is-needed': this.props.needs.indexOf(tier.id) !== -1
      });

      return React.createElement(
        'li',
        { className: boxClasses, key: tier.id },
        React.createElement(
          'p',
          { className: 'tier' },
          tier.id
        ),
        React.createElement(
          'div',
          { className: 'list-price' },
          React.createElement(
            'span',
            { className: 'currency' },
            '$'
          ),
          React.createElement(
            'span',
            null,
            tier.price
          )
        ),
        React.createElement(
          'div',
          { className: 'employee' },
          React.createElement(
            'p',
            null,
            t('pr. month #better_paywall')
          ),
          React.createElement(
            'p',
            null,
            t('pr. employee #better_paywall')
          )
        ),
        this.renderCallToActionButton(tier.id),
        React.createElement(
          'section',
          { className: 'features' },
          tier.features.map(function (feature, idx) {
            return React.createElement(
              'p',
              { key: idx },
              React.createElement('img', { src: '/images/components/PricingUpgradeOnlyBoxComponent/plus.png' }),
              feature
            );
          })
        )
      );
    },

    renderCallToActionButton: function renderCallToActionButton(tierId) {
      var order = _.pluck(tiers, 'id');
      var current = tierId === this.state.currentTier;
      var isDowngrade = order.indexOf(tierId) < order.indexOf(this.state.currentTier);
      var buttonText = t('Get {0} #better_paywall');
      var clickable = true;
      var track = this.props.tracking;

      if (current) {
        clickable = false;
        buttonText = t('Current #better_paywall');
      } else if (tierId === 'free') {
        clickable = this.props.downgrade;
        buttonText = t('End plan #better_paywall');
      } else if (isDowngrade) {
        clickable = this.props.downgrade;
        buttonText = t('Downgrade #better_paywall');
      }

      buttonText = buttonText.format(tierId);

      var classNames = cx({
        'button-new': true,
        'disabled': isDowngrade && !this.props.downgrade,
        'is-current': current,
        'is-not-needed': !isDowngrade && this.props.needs.indexOf(tierId) === -1,
        'primary baby-button': this.props.needs.indexOf(tierId) !== -1 && !current || this.props.showFree === false
      });

      var clickFunction = (function (e) {
        if (current || tierId === 'free') {
          e.preventDefault();
          return;
        }

        if (clickable) {
          if (!isDowngrade && this.state.currentTier !== 'free') {
            e.preventDefault();

            this.props.closeModalDelegate();
            this.setState({
              selectedTier: PricingTierPlans[tierId],
              isUpgrade: !isDowngrade
            }, function () {
              this.renderChangeTierComponent();
            });
          }
        }
      }).bind(this);

      return React.createElement(
        'div',
        { className: 'call-to-action' },
        React.createElement(
          'a',
          { href: this.state.upgradePath + '?tier=' + tierId, onClick: clickFunction, className: classNames },
          buttonText
        )
      );
    }
  });

  return PricingUpgradeOnlyBoxComponent;
});
